<div class="login-root">

  <!-- Left hero panel — static, never transforms -->
  <div class="login-hero" aria-hidden="true">
    <div class="hero-overlay">
      <span class="hero-app-name">Cloud Labs</span>
      <span class="hero-tagline">Spin up. Dive in. Effortless.</span>
    </div>
  </div>

  <!-- Right form panel -->
  <div class="login-form-panel">
    <!-- Scattered domain icons — purely decorative -->
    <div class="hero-bg-icons" aria-hidden="true">
      <span class="bgi material-icons i1">computer</span>
      <span class="bgi material-icons i2">person_outline</span>
      <span class="bgi material-icons i3">desktop_windows</span>
      <span class="bgi material-icons i4">groups</span>
      <span class="bgi material-icons i5">security</span>
      <span class="bgi material-icons i6">cloud_queue</span>
      <span class="bgi material-icons i7">dns</span>
      <span class="bgi material-icons i8">monitor</span>
      <span class="bgi material-icons i9">policy</span>
      <span class="bgi material-icons i10">computer</span>
      <span class="bgi material-icons i11">storage</span>
      <span class="bgi material-icons i12">terminal</span>
      <span class="bgi material-icons i13">manage_accounts</span>
      <span class="bgi material-icons i14">settings_remote</span>
      <span class="bgi material-icons i15">cloud</span>
      <span class="bgi material-icons i16">settings</span>
      <span class="bgi material-icons i17">school</span>
      <span class="bgi material-icons i18">lock_outline</span>
      <span class="bgi material-icons i19">wifi</span>
      <span class="bgi material-icons i20">devices</span>
      <span class="bgi material-icons i21">hub</span>
      <span class="bgi material-icons i22">vpn_lock</span>
      <span class="bgi material-icons i23">memory</span>
      <span class="bgi material-icons i24">cloud_done</span>
      <span class="bgi material-icons i25">router</span>
      <span class="bgi material-icons i26">app_registration</span>
    </div>

    <!-- ══ 3D flip scene ══════════════════════════════════════════════════ -->
    <div class="login-card-scene">
      <div class="login-card-flipper"
           [style.transform]="'rotateY(' + rotation + 'deg)'">

        <!-- ▓▓ FRONT FACE — Login ▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓ -->
        <div class="card-face card-front login-card">

          <img src="../../../../assets/images/logo.png" alt="Resource Allocator Logo" class="brand-logo" />
          <h1 class="login-title">Welcome back</h1>
          <p class="login-subtitle">Sign in to your account</p>

          <form [formGroup]="loginForm" (ngSubmit)="login()" class="lf-form">

            <mat-form-field appearance="outline" class="full-width">
              <mat-label>Username</mat-label>
              <mat-icon matPrefix>person_outline</mat-icon>
              <input matInput formControlName="loginId"
                     autocomplete="username" autocorrect="off" autocapitalize="none" />
              <mat-error *ngIf="loginId?.hasError('required')">Username is required</mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline" class="full-width">
              <mat-label>Password</mat-label>
              <mat-icon matPrefix>lock_outline</mat-icon>
              <input matInput formControlName="password"
                     [type]="showPassword ? 'text' : 'password'"
                     autocomplete="current-password" />
              <button mat-icon-button matSuffix type="button"
                      (click)="togglePasswordVisibility()"
                      [attr.aria-label]="showPassword ? 'Hide password' : 'Show password'">
                <mat-icon>{{ showPassword ? 'visibility_off' : 'visibility' }}</mat-icon>
              </button>
              <mat-error *ngIf="password?.hasError('required')">Password is required</mat-error>
            </mat-form-field>

            <div *ngIf="errorMessage" class="login-error-banner">
              <mat-icon class="error-icon">error_outline</mat-icon>
              <span>{{ errorMessage }}</span>
            </div>

            <button mat-raised-button color="primary" type="submit" class="sign-in-btn"
                    [disabled]="isLoading || loginForm.invalid">
              <mat-spinner *ngIf="isLoading" diameter="20" class="btn-spinner"></mat-spinner>
              <mat-icon *ngIf="!isLoading">login</mat-icon>
              <span>{{ isLoading ? 'Signing in\u2026' : 'Sign In' }}</span>
            </button>

          </form>

          <!-- Pinned nav row: Sign Up ← left   right → Forgot Password -->
          <div class="face-nav split">
            <a class="auth-link" (click)="goToSignup()">New User? Sign Up</a>
            <a class="auth-link" (click)="goToForgot()">Forgot password?</a>
          </div>

        </div>
        <!-- ▓▓ /FRONT FACE ▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓ -->


        <!-- ▓▓ BACK FACE — Sign Up or Forgot Password ▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓ -->
        <div class="card-face card-back">

          <!-- ── Sign Up ─────────────────────────────────────────────────── -->
          <ng-container *ngIf="backFaceContent === 'signup'">

            <h1 class="auth-title">Create Account</h1>
            <p class="auth-subtitle">Fill in the details below to get started</p>

            <form [formGroup]="signupForm" (ngSubmit)="onSignupSubmit()" class="back-form">

              <div *ngIf="serverErrorMessage" class="back-error-banner">
                <mat-icon class="error-icon">error_outline</mat-icon>
                <span>{{ serverErrorMessage }}</span>
              </div>

              <!-- Full name -->
              <mat-form-field appearance="outline" class="full-width">
                <mat-label>Full Name</mat-label>
                <mat-icon matPrefix>person_outline</mat-icon>
                <input matInput formControlName="name" autocomplete="name" />
                <mat-error *ngIf="signupName?.hasError('required')">Name is required</mat-error>
                <mat-error *ngIf="signupName?.hasError('minlength')">Name must be at least 2 characters</mat-error>
              </mat-form-field>

              <!-- Email with live existence check -->
              <mat-form-field appearance="outline" class="full-width">
                <mat-label>Email Address</mat-label>
                <mat-icon matPrefix>alternate_email</mat-icon>
                <input matInput formControlName="loginId" type="email" autocomplete="email" />
                <mat-spinner matSuffix *ngIf="signupEmailChecking" diameter="18" class="suffix-spinner"></mat-spinner>
                <mat-icon matSuffix class="suffix-icon icon-avail" *ngIf="!signupEmailChecking && signupEmailTaken === false">check_circle</mat-icon>
                <mat-icon matSuffix class="suffix-icon icon-taken" *ngIf="!signupEmailChecking && signupEmailTaken === true">cancel</mat-icon>
                <mat-error *ngIf="signupLoginId?.hasError('required')">Email is required</mat-error>
                <mat-error *ngIf="signupLoginId?.hasError('email')">Enter a valid email address</mat-error>
              </mat-form-field>

              <div class="back-error-banner" *ngIf="!signupEmailChecking && signupEmailTaken === true">
                <mat-icon class="error-icon">person_off</mat-icon>
                <span>This email is already registered.</span>
              </div>

              <!-- Password -->
              <mat-form-field appearance="outline" class="full-width">
                <mat-label>Password</mat-label>
                <mat-icon matPrefix>lock_outline</mat-icon>
                <input matInput formControlName="password"
                       [type]="showSignupPassword ? 'text' : 'password'"
                       autocomplete="new-password" />
                <button mat-icon-button matSuffix type="button"
                        (click)="toggleSignupPasswordVisibility()"
                        [attr.aria-label]="showSignupPassword ? 'Hide password' : 'Show password'">
                  <mat-icon>{{ showSignupPassword ? 'visibility_off' : 'visibility' }}</mat-icon>
                </button>
                <mat-error *ngIf="signupPassword?.hasError('required')">Password is required</mat-error>
                <mat-error *ngIf="signupPassword?.hasError('passwordStrength')">Must include uppercase, lowercase, number and special character</mat-error>
              </mat-form-field>

              <div class="pw-requirements" *ngIf="signupPassword?.value?.length > 0">
                <div class="pw-req" [class.pw-met]="passwordValidation.minLength">
                  <mat-icon>{{ passwordValidation.minLength ? 'check_circle' : 'radio_button_unchecked' }}</mat-icon>
                  <span>At least 8 characters</span>
                </div>
                <div class="pw-req" [class.pw-met]="passwordValidation.hasUppercase">
                  <mat-icon>{{ passwordValidation.hasUppercase ? 'check_circle' : 'radio_button_unchecked' }}</mat-icon>
                  <span>One uppercase letter</span>
                </div>
                <div class="pw-req" [class.pw-met]="passwordValidation.hasLowercase">
                  <mat-icon>{{ passwordValidation.hasLowercase ? 'check_circle' : 'radio_button_unchecked' }}</mat-icon>
                  <span>One lowercase letter</span>
                </div>
                <div class="pw-req" [class.pw-met]="passwordValidation.hasNumber">
                  <mat-icon>{{ passwordValidation.hasNumber ? 'check_circle' : 'radio_button_unchecked' }}</mat-icon>
                  <span>One number</span>
                </div>
                <div class="pw-req" [class.pw-met]="passwordValidation.hasSpecial">
                  <mat-icon>{{ passwordValidation.hasSpecial ? 'check_circle' : 'radio_button_unchecked' }}</mat-icon>
                  <span>One special character</span>
                </div>
              </div>

              <!-- Confirm password -->
              <mat-form-field appearance="outline" class="full-width">
                <mat-label>Confirm Password</mat-label>
                <mat-icon matPrefix>lock_outline</mat-icon>
                <input matInput formControlName="confirmPassword"
                       [type]="showConfirmPassword ? 'text' : 'password'"
                       autocomplete="new-password" />
                <button mat-icon-button matSuffix type="button"
                        (click)="toggleConfirmPasswordVisibility()"
                        [attr.aria-label]="showConfirmPassword ? 'Hide password' : 'Show password'">
                  <mat-icon>{{ showConfirmPassword ? 'visibility_off' : 'visibility' }}</mat-icon>
                </button>
                <mat-error *ngIf="signupControls['confirmPassword'].hasError('required')">Confirm password is required</mat-error>
                <mat-error *ngIf="signupForm.hasError('passwordMismatch') && signupControls['confirmPassword'].touched">Passwords do not match</mat-error>
              </mat-form-field>

              <div class="pw-requirements" *ngIf="signupConfirmPassword?.value?.length > 0">
                <div class="pw-req" [class.pw-met]="passwordValidation.passwordsMatch">
                  <mat-icon>{{ passwordValidation.passwordsMatch ? 'check_circle' : 'radio_button_unchecked' }}</mat-icon>
                  <span>Passwords match</span>
                </div>
              </div>

              <!-- Submit: disabled while checking or email taken -->
              <button mat-raised-button color="primary" type="submit" class="back-submit-btn"
                      [disabled]="signupForm.invalid || isSubmitting || !isPasswordValid() || signupEmailTaken === true || signupEmailChecking">
                <mat-spinner *ngIf="isSubmitting" diameter="20" class="btn-spinner"></mat-spinner>
                <mat-icon *ngIf="!isSubmitting">person_add</mat-icon>
                <span>{{ isSubmitting ? 'Creating Account\u2026' : 'Create Account' }}</span>
              </button>

            </form>

            <!-- Pinned nav row: Back to Login ← left -->
            <div class="face-nav to-start">
              <a class="auth-link" (click)="goBackFromSignup()">Back to Sign In</a>
            </div>

          </ng-container>
          <!-- ── /Sign Up ──────────────────────────────────────────────── -->


          <!-- ── Forgot Password ─────────────────────────────────────────── -->
          <ng-container *ngIf="backFaceContent === 'forgot'">

            <!-- Step 1: Email input + Send Code -->
            <ng-container *ngIf="forgotStep === 1">
              <h1 class="auth-title">Reset Password</h1>
              <p class="auth-subtitle">Enter your account email to receive a reset code</p>

              <form [formGroup]="forgotPasswordForm" (ngSubmit)="submitForgotPassword()" class="back-form">

                <!-- Email field with live check -->
                <mat-form-field appearance="outline" class="full-width">
                  <mat-label>Email Address</mat-label>
                  <mat-icon matPrefix>alternate_email</mat-icon>
                  <input matInput formControlName="loginId" type="email" autocomplete="email" />
                  <mat-spinner matSuffix *ngIf="forgotEmailChecking" diameter="18" class="suffix-spinner"></mat-spinner>
                  <mat-icon matSuffix class="suffix-icon icon-avail" *ngIf="!forgotEmailChecking && forgotUserExists === true">check_circle</mat-icon>
                  <mat-error *ngIf="forgotLoginId?.hasError('required')">Email is required</mat-error>
                  <mat-error *ngIf="forgotLoginId?.hasError('email')">Enter a valid email address</mat-error>
                </mat-form-field>

                <div class="back-error-banner" *ngIf="!forgotEmailChecking && forgotUserExists === false">
                  <mat-icon class="error-icon">person_off</mat-icon>
                  <span>No account found with this email</span>
                </div>

                <div *ngIf="forgotErrorMessage" class="back-error-banner">
                  <mat-icon class="error-icon">error_outline</mat-icon>
                  <span>{{ forgotErrorMessage }}</span>
                </div>

                <!-- Button disabled until user is confirmed to exist -->
                <button mat-raised-button color="primary" type="submit" class="back-submit-btn"
                        [disabled]="isForgotLoading || forgotPasswordForm.invalid || forgotUserExists !== true || sendCodeCooldown > 0">
                  <mat-spinner *ngIf="isForgotLoading" diameter="20" class="btn-spinner"></mat-spinner>
                  <mat-icon *ngIf="!isForgotLoading && sendCodeCooldown === 0">send</mat-icon>
                  <span *ngIf="sendCodeCooldown === 0">{{ isForgotLoading ? 'Sending\u2026' : 'Send Reset Code' }}</span>
                  <span *ngIf="sendCodeCooldown > 0">Resend in {{ sendCodeCooldown }}s</span>
                </button>

              </form>
            </ng-container>

            <!-- Step 2: OTP + new password inline (no external navigation) -->
            <ng-container *ngIf="forgotStep === 2">
              <h1 class="auth-title">Enter passcode</h1>
              <p class="auth-subtitle">6-digit code sent to your inbox</p>

              <div class="otp-sent-chip">
                <mat-icon class="otp-sent-icon">mark_email_read</mat-icon>
                <span>{{ forgotPasswordForm.get('loginId')?.value }}</span>
              </div>

              <form [formGroup]="resetPasswordForm" (ngSubmit)="submitResetPassword()" class="back-form">

                <div *ngIf="resetErrorMessage" class="back-error-banner">
                  <mat-icon class="error-icon">error_outline</mat-icon>
                  <span>{{ resetErrorMessage }}</span>
                </div>

                <!-- 6-digit OTP -->
                <mat-form-field appearance="outline" class="full-width">
                  <mat-label>6-Digit Code</mat-label>
                  <mat-icon matPrefix>pin</mat-icon>
                  <input matInput formControlName="otpCode" type="text" inputmode="numeric"
                         maxlength="6" placeholder="000000" autocomplete="one-time-code"
                         class="otp-text-input" />
                  <mat-error *ngIf="resetPasswordForm.get('otpCode')?.hasError('required')">Code is required</mat-error>
                  <mat-error *ngIf="resetPasswordForm.get('otpCode')?.hasError('pattern')">Enter a valid 6-digit code</mat-error>
                </mat-form-field>

                <!-- New password -->
                <mat-form-field appearance="outline" class="full-width">
                  <mat-label>New Password</mat-label>
                  <mat-icon matPrefix>lock_outline</mat-icon>
                  <input matInput formControlName="password"
                         [type]="showResetNewPassword ? 'text' : 'password'"
                         autocomplete="new-password" />
                  <button mat-icon-button matSuffix type="button"
                          (click)="toggleResetNewPasswordVisibility()"
                          [attr.aria-label]="showResetNewPassword ? 'Hide password' : 'Show password'">
                    <mat-icon>{{ showResetNewPassword ? 'visibility_off' : 'visibility' }}</mat-icon>
                  </button>
                  <mat-error *ngIf="resetPasswordForm.get('password')?.hasError('required')">Password is required</mat-error>
                  <mat-error *ngIf="resetPasswordForm.get('password')?.hasError('passwordStrength')">Must include uppercase, lowercase, number and special character</mat-error>
                </mat-form-field>

                <div class="pw-requirements" *ngIf="resetPasswordForm.get('password')?.value?.length > 0">
                  <div class="pw-req" [class.pw-met]="resetPasswordValidation.minLength">
                    <mat-icon>{{ resetPasswordValidation.minLength ? 'check_circle' : 'radio_button_unchecked' }}</mat-icon>
                    <span>At least 8 characters</span>
                  </div>
                  <div class="pw-req" [class.pw-met]="resetPasswordValidation.hasUppercase">
                    <mat-icon>{{ resetPasswordValidation.hasUppercase ? 'check_circle' : 'radio_button_unchecked' }}</mat-icon>
                    <span>One uppercase letter</span>
                  </div>
                  <div class="pw-req" [class.pw-met]="resetPasswordValidation.hasLowercase">
                    <mat-icon>{{ resetPasswordValidation.hasLowercase ? 'check_circle' : 'radio_button_unchecked' }}</mat-icon>
                    <span>One lowercase letter</span>
                  </div>
                  <div class="pw-req" [class.pw-met]="resetPasswordValidation.hasNumber">
                    <mat-icon>{{ resetPasswordValidation.hasNumber ? 'check_circle' : 'radio_button_unchecked' }}</mat-icon>
                    <span>One number</span>
                  </div>
                  <div class="pw-req" [class.pw-met]="resetPasswordValidation.hasSpecial">
                    <mat-icon>{{ resetPasswordValidation.hasSpecial ? 'check_circle' : 'radio_button_unchecked' }}</mat-icon>
                    <span>One special character</span>
                  </div>
                </div>

                <!-- Confirm new password -->
                <mat-form-field appearance="outline" class="full-width">
                  <mat-label>Confirm New Password</mat-label>
                  <mat-icon matPrefix>lock_outline</mat-icon>
                  <input matInput formControlName="confirmPassword"
                         [type]="showResetConfirmPassword ? 'text' : 'password'"
                         autocomplete="new-password" />
                  <button mat-icon-button matSuffix type="button"
                          (click)="toggleResetConfirmPasswordVisibility()"
                          [attr.aria-label]="showResetConfirmPassword ? 'Hide password' : 'Show password'">
                    <mat-icon>{{ showResetConfirmPassword ? 'visibility_off' : 'visibility' }}</mat-icon>
                  </button>
                  <mat-error *ngIf="resetPasswordForm.get('confirmPassword')?.hasError('required')">Confirm password is required</mat-error>
                  <mat-error *ngIf="resetPasswordForm.hasError('passwordMismatch') && resetPasswordForm.get('confirmPassword')?.touched">Passwords do not match</mat-error>
                </mat-form-field>

                <div class="pw-requirements" *ngIf="resetPasswordForm.get('confirmPassword')?.value?.length > 0">
                  <div class="pw-req" [class.pw-met]="resetPasswordValidation.passwordsMatch">
                    <mat-icon>{{ resetPasswordValidation.passwordsMatch ? 'check_circle' : 'radio_button_unchecked' }}</mat-icon>
                    <span>Passwords match</span>
                  </div>
                </div>

                <button mat-raised-button color="primary" type="submit" class="back-submit-btn"
                        [disabled]="resetPasswordForm.invalid || isResetting || !isResetPasswordValid()">
                  <mat-spinner *ngIf="isResetting" diameter="20" class="btn-spinner"></mat-spinner>
                  <mat-icon *ngIf="!isResetting">shield</mat-icon>
                  <span>{{ isResetting ? 'Resetting\u2026' : 'Reset Password' }}</span>
                </button>

              </form>

              <!-- Resend link with cooldown -->
              <div class="resend-row">
                <span class="muted-label">Didn't receive it?</span>
                <a class="auth-link"
                   [class.disabled-link]="sendCodeCooldown > 0 || isForgotLoading"
                   (click)="sendCodeCooldown === 0 && !isForgotLoading && submitForgotPassword()">
                  {{ sendCodeCooldown > 0 ? 'Resend in ' + sendCodeCooldown + 's' : 'Resend Code' }}
                </a>
              </div>

            </ng-container>

            <!-- Pinned nav row: Back to Login → right (mirrors the "Forgot password?" origin) -->
            <div class="face-nav to-end">
              <a class="auth-link" (click)="goBackFromForgot()">Back to Sign In</a>
            </div>

          </ng-container>
          <!-- ── /Forgot Password ─────────────────────────────────────── -->

        </div>
        <!-- ▓▓ /BACK FACE ▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓ -->

      </div><!-- /login-card-flipper -->
    </div><!-- /login-card-scene -->

  </div><!-- /login-form-panel -->

</div>

